import { createDV360LineItemPayload } from '../../../../lineItemHelpers'

import { END_DATE, START_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import { ACTIVE, STATUS } from '../../../../fields'

export const NAME = 'name'
export const PIXELS = 'pixels'

export const DATE_RANGE_OPTION = 'date_range_option'
export const FULL_CAMPAIGN_DATE_RANGE = 'full_campaign_date_range'
export const CUSTOM_DATE_RANGE = 'custom_date_range'

export const getInitialValues = campaign => {
  const { date_start: campaignDateStart, date_stop: campaignDateStop } = campaign

  return {
    [NAME]: '',
    // pixels
    [PIXELS]: [],
    // dates
    [START_DATE]: new Date(campaignDateStart),
    [END_DATE]: new Date(campaignDateStop),
    [DATE_RANGE_OPTION]: FULL_CAMPAIGN_DATE_RANGE,
    // status
    [STATUS]: ACTIVE
  }
}

export const transformValuesToBE = (values, campaign) => {
  const { date_start: campaignDateStart, date_stop: campaignDateStop } = campaign

  const isFullCampaignDateRange = values[DATE_RANGE_OPTION] === FULL_CAMPAIGN_DATE_RANGE

  return createDV360LineItemPayload({
    name: values[NAME],
    status: values[STATUS],
    startDate: isFullCampaignDateRange ? campaignDateStart : values[START_DATE],
    endDate: isFullCampaignDateRange ? campaignDateStop : values[END_DATE],
    pixels: values[PIXELS]
  })
}
